/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './alert-dialog.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@covalent/core/dialogs/dialog.component';
import * as i3 from '../dialog.component.ngfactory';
import * as i4 from '@angular/common';
import * as i5 from '@covalent/core/dialogs/alert-dialog/alert-dialog.component';
import * as i6 from '../../../../@angular/material/typings/index.ngfactory';
import * as i7 from '@angular/material';
const styles_TdAlertDialogComponent:any[] = [i0.styles];
export const RenderType_TdAlertDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdAlertDialogComponent,data:{}});
function View_TdAlertDialogComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-dialog-title',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,[[1,4]],0,i2.TdDialogTitleDirective,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    ','\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.title;
        _ck(_v,2,0,currVal_0);
      });
}
export function View_TdAlertDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),22,'td-dialog',([] as any[]),
      (null as any),(null as any),(null as any),i3.View_TdDialogComponent_0,i3.RenderType_TdDialogComponent)),
      i1.ɵdid(1097728,(null as any),3,i2.TdDialogComponent,([] as any[]),(null as any),
          (null as any)),i1.ɵqud(603979776,1,{dialogTitle:1}),i1.ɵqud(603979776,2,
          {dialogContent:1}),i1.ɵqud(603979776,3,{dialogActions:1}),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_TdAlertDialogComponent_1)),
      i1.ɵdid(16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),
          i1.ɵeld(0,(null as any),1,2,'td-dialog-content',[['class','md-subhead tc-grey-700']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,[[2,4]],0,i2.TdDialogContentDirective,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    ','\n  '])),(_l()(),
          i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),2,8,'td-dialog-actions',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,[[3,4]],0,i2.TdDialogActionsDirective,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),4,'button',[['class','mat-button'],['color',
              'accent'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i5.TdAlertDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),(_l()(),
          i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i5.TdAlertDialogComponent = _v.component;
        const currVal_0:any = _co.title;
        _ck(_v,7,0,currVal_0);
        const currVal_3:any = 'accent';
        _ck(_v,18,0,currVal_3);
      },(_ck,_v) => {
        var _co:i5.TdAlertDialogComponent = _v.component;
        const currVal_1:any = _co.message;
        _ck(_v,11,0,currVal_1);
        const currVal_2:any = (i1.ɵnov(_v,18).disabled || (null as any));
        _ck(_v,16,0,currVal_2);
        const currVal_4:any = _co.closeButton;
        _ck(_v,20,0,currVal_4);
      });
}
export function View_TdAlertDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'td-alert-dialog',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdAlertDialogComponent_0,
      RenderType_TdAlertDialogComponent)),i1.ɵdid(49152,(null as any),0,i5.TdAlertDialogComponent,
      [i7.MdDialogRef],(null as any),(null as any))],(null as any),(null as any));
}
export const TdAlertDialogComponentNgFactory:i1.ComponentFactory<i5.TdAlertDialogComponent> = i1.ɵccf('td-alert-dialog',
    i5.TdAlertDialogComponent,View_TdAlertDialogComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/dialogs/alert-dialog/alert-dialog.component.ngfactory.ts